import { useMemo } from "react";

const useCanRunAds = () => useMemo(() => !!window.canRunBrads);

export default useCanRunAds;
